// extracted by mini-css-extract-plugin
export default {"item-list":"SaladsMobile_item-list__rlyPv","item":"SaladsMobile_item__yYUrk","category-title":"SaladsMobile_category-title__KoLHb"};